import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BellIcon, MessageSquareIcon, UserIcon, SettingsIcon, LogOutIcon, ChevronDownIcon, UsersIcon, ActivityIcon, WrenchIcon, AwardIcon, ChromeIcon, TrendingUpIcon, SparklesIcon, VideoIcon, ShoppingBagIcon, ExternalLinkIcon } from 'lucide-react';
export function HeaderBar() {
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showMessages, setShowMessages] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showUtilities, setShowUtilities] = useState(false);
  const notifications = [{
    id: 1,
    type: 'alert',
    title: 'Program Performance Alert',
    message: 'High-Intent Blitz is underperforming by 15%',
    time: '5m ago',
    unread: true
  }, {
    id: 2,
    type: 'success',
    title: 'Play Completed',
    message: 'Executive Nurture completed successfully',
    time: '1h ago',
    unread: true
  }, {
    id: 3,
    type: 'info',
    title: 'New Integration Available',
    message: 'HubSpot integration is now available',
    time: '3h ago',
    unread: false
  }];
  const messages = [{
    id: 1,
    from: 'Sarah Chen',
    message: 'Can you review the Q4 program plan?',
    time: '10m ago',
    unread: true
  }, {
    id: 2,
    from: 'Mike Johnson',
    message: 'New play template is ready for review',
    time: '1h ago',
    unread: true
  }, {
    id: 3,
    from: 'Team Notification',
    message: 'Weekly sync scheduled for tomorrow',
    time: '2h ago',
    unread: false
  }];
  const unreadNotifications = notifications.filter(n => n.unread).length;
  const unreadMessages = messages.filter(m => m.unread).length;
  return <div className="h-14 bg-white border-b border-gray-200 flex items-center justify-end px-4 lg:px-6 gap-2" data-id="element-1315">
      {/* Utilities Dropdown */}
      <div className="relative" data-id="element-1316">
        <button onClick={() => setShowUtilities(!showUtilities)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors relative" data-id="element-1317">
          <WrenchIcon className="w-5 h-5 text-gray-600" data-id="element-1318" />
        </button>
        {showUtilities && <>
            <div className="fixed inset-0 z-40" onClick={() => setShowUtilities(false)} data-id="element-1319" />
            <div className="absolute right-0 top-full mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50" data-id="element-1320">
              <div className="px-4 py-2 border-b border-gray-200" data-id="element-1321">
                <p className="text-xs font-semibold text-gray-600 uppercase" data-id="element-1322">
                  Tools & Resources
                </p>
              </div>
              <button onClick={() => {
            navigate('/free-tools/forecasting');
            setShowUtilities(false);
          }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1323">
                <TrendingUpIcon className="w-4 h-4" data-id="element-1324" />
                <span className="text-sm" data-id="element-1325">Forecasting Tool</span>
              </button>
              <button onClick={() => {
            navigate('/free-tools/prompts');
            setShowUtilities(false);
          }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1326">
                <SparklesIcon className="w-4 h-4" data-id="element-1327" />
                <span className="text-sm" data-id="element-1328">Prompt Library</span>
              </button>
              <button onClick={() => {
            navigate('/free-tools/extension');
            setShowUtilities(false);
          }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1329">
                <ChromeIcon className="w-4 h-4" data-id="element-1330" />
                <span className="text-sm" data-id="element-1331">Browser Extension</span>
              </button>
              <button onClick={() => {
            navigate('/free-tools/training');
            setShowUtilities(false);
          }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1332">
                <AwardIcon className="w-4 h-4" data-id="element-1333" />
                <span className="text-sm" data-id="element-1334">Training Portal</span>
              </button>
              <div className="border-t border-gray-200 mt-2 pt-2" data-id="element-1335">
                <button onClick={() => {
              navigate('/community/discussions');
              setShowUtilities(false);
            }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1336">
                  <MessageSquareIcon className="w-4 h-4" data-id="element-1337" />
                  <span className="text-sm" data-id="element-1338">Community Hub</span>
                </button>
                <button onClick={() => {
              navigate('/demo/upsell');
              setShowUtilities(false);
            }} className="w-full flex items-center gap-3 px-4 py-2.5 text-purple-700 hover:bg-purple-50 transition-colors" data-id="element-1339">
                  <SparklesIcon className="w-4 h-4" data-id="element-1340" />
                  <span className="text-sm" data-id="element-1341">Upsell Demo</span>
                </button>
                <div className="border-t border-gray-200 my-2" data-id="element-1342" />
                <button onClick={() => {
              navigate('/website');
              setShowUtilities(false);
            }} className="w-full flex items-center gap-3 px-4 py-2.5 text-blue-700 hover:bg-blue-50 transition-colors" data-id="element-1343">
                  <ExternalLinkIcon className="w-4 h-4" data-id="element-1344" />
                  <span className="text-sm" data-id="element-1345">Visit Website</span>
                </button>
                <button onClick={() => {
              navigate('/login');
              setShowUtilities(false);
            }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1346">
                  <UserIcon className="w-4 h-4" data-id="element-1347" />
                  <span className="text-sm" data-id="element-1348">Sign In Page</span>
                </button>
                <button onClick={() => {
              navigate('/signup');
              setShowUtilities(false);
            }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1349">
                  <UserIcon className="w-4 h-4" data-id="element-1350" />
                  <span className="text-sm" data-id="element-1351">Sign Up Page</span>
                </button>
              </div>
            </div>
          </>}
      </div>
      {/* Messages */}
      <div className="relative" data-id="element-1352">
        <button onClick={() => setShowMessages(!showMessages)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors relative" data-id="element-1353">
          <MessageSquareIcon className="w-5 h-5 text-gray-600" data-id="element-1354" />
          {unreadMessages > 0 && <span className="absolute top-1 right-1 w-2 h-2 bg-blue-600 rounded-full" data-id="element-1355" />}
        </button>
        {showMessages && <>
            <div className="fixed inset-0 z-40" onClick={() => setShowMessages(false)} data-id="element-1356" />
            <div className="absolute right-0 top-full mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-50" data-id="element-1357">
              <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between" data-id="element-1358">
                <h3 className="text-sm font-semibold text-gray-900" data-id="element-1359">
                  Messages
                </h3>
                {unreadMessages > 0 && <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full" data-id="element-1360">
                    {unreadMessages} new
                  </span>}
              </div>
              <div className="max-h-96 overflow-y-auto" data-id="element-1361">
                {messages.map(message => <button key={message.id} onClick={() => {
              navigate('/collaboration/team');
              setShowMessages(false);
            }} className={`w-full p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors text-left ${message.unread ? 'bg-blue-50' : ''}`} data-id="element-1362">
                    <div className="flex items-start gap-3" data-id="element-1363">
                      <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 text-xs font-medium flex-shrink-0" data-id="element-1364">
                        {message.from.split(' ').map(n => n[0]).join('')}
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-1365">
                        <div className="flex items-center justify-between mb-1" data-id="element-1366">
                          <p className="text-sm font-medium text-gray-900" data-id="element-1367">
                            {message.from}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-1368">
                            {message.time}
                          </p>
                        </div>
                        <p className="text-sm text-gray-600 truncate" data-id="element-1369">
                          {message.message}
                        </p>
                      </div>
                    </div>
                  </button>)}
              </div>
              <div className="p-3 border-t border-gray-200" data-id="element-1370">
                <button onClick={() => {
              navigate('/collaboration/team');
              setShowMessages(false);
            }} className="w-full text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-1371">
                  View all messages
                </button>
              </div>
            </div>
          </>}
      </div>
      {/* Notifications */}
      <div className="relative" data-id="element-1372">
        <button onClick={() => setShowNotifications(!showNotifications)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors relative" data-id="element-1373">
          <BellIcon className="w-5 h-5 text-gray-600" data-id="element-1374" />
          {unreadNotifications > 0 && <span className="absolute top-1 right-1 w-2 h-2 bg-red-600 rounded-full" data-id="element-1375" />}
        </button>
        {showNotifications && <>
            <div className="fixed inset-0 z-40" onClick={() => setShowNotifications(false)} data-id="element-1376" />
            <div className="absolute right-0 top-full mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-50" data-id="element-1377">
              <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between" data-id="element-1378">
                <h3 className="text-sm font-semibold text-gray-900" data-id="element-1379">
                  Notifications
                </h3>
                {unreadNotifications > 0 && <span className="px-2 py-1 bg-red-100 text-red-700 text-xs font-medium rounded-full" data-id="element-1380">
                    {unreadNotifications} new
                  </span>}
              </div>
              <div className="max-h-96 overflow-y-auto" data-id="element-1381">
                {notifications.map(notification => <button key={notification.id} onClick={() => {
              navigate('/collaboration/notifications');
              setShowNotifications(false);
            }} className={`w-full p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors text-left ${notification.unread ? 'bg-red-50' : ''}`} data-id="element-1382">
                    <div className="flex items-center justify-between mb-2" data-id="element-1383">
                      <p className="text-sm font-medium text-gray-900" data-id="element-1384">
                        {notification.title}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-1385">
                        {notification.time}
                      </p>
                    </div>
                    <p className="text-sm text-gray-600" data-id="element-1386">
                      {notification.message}
                    </p>
                  </button>)}
              </div>
              <div className="p-3 border-t border-gray-200" data-id="element-1387">
                <button onClick={() => {
              navigate('/collaboration/notifications');
              setShowNotifications(false);
            }} className="w-full text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-1388">
                  View all notifications
                </button>
              </div>
            </div>
          </>}
      </div>
      {/* User Menu */}
      <div className="relative" data-id="element-1389">
        <button onClick={() => setShowUserMenu(!showUserMenu)} className="flex items-center gap-2 p-1.5 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-1390">
          <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-1391">
            JD
          </div>
          <ChevronDownIcon className="w-4 h-4 text-gray-500" data-id="element-1392" />
        </button>
        {showUserMenu && <>
            <div className="fixed inset-0 z-40" onClick={() => setShowUserMenu(false)} data-id="element-1393" />
            <div className="absolute right-0 top-full mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50" data-id="element-1394">
              <div className="px-4 py-3 border-b border-gray-200" data-id="element-1395">
                <p className="text-sm font-medium text-gray-900" data-id="element-1396">John Doe</p>
                <p className="text-xs text-gray-600" data-id="element-1397">john@company.com</p>
              </div>
              <button onClick={() => {
            navigate('/collaboration/team');
            setShowUserMenu(false);
          }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1398">
                <UsersIcon className="w-4 h-4" data-id="element-1399" />
                <span className="text-sm" data-id="element-1400">Team</span>
              </button>
              <button onClick={() => {
            navigate('/collaboration/activity');
            setShowUserMenu(false);
          }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1401">
                <ActivityIcon className="w-4 h-4" data-id="element-1402" />
                <span className="text-sm" data-id="element-1403">Activity Feed</span>
              </button>
              <div className="border-t border-gray-200 mt-2 pt-2" data-id="element-1404">
                <button onClick={() => {
              setShowUserMenu(false);
            }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1405">
                  <SettingsIcon className="w-4 h-4" data-id="element-1406" />
                  <span className="text-sm" data-id="element-1407">Settings</span>
                </button>
                <button onClick={() => {
              setShowUserMenu(false);
            }} className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1408">
                  <LogOutIcon className="w-4 h-4" data-id="element-1409" />
                  <span className="text-sm" data-id="element-1410">Sign Out</span>
                </button>
              </div>
            </div>
          </>}
      </div>
    </div>;
}